import Story from "./Story";


const Main3 = () => {

    return ( 
      <div className="container d-flex">
        <div className="row">
          <div className="col">
           <h1>Story</h1>  
            <Story/>
          </div>
        </div>
      </div>
    )
}

export default Main3